import React, { useState } from "react";
import { ReconciliationGroupTableCard } from "./reconciliationGroupTable/ReconciliationGroupTableCard";
import { AccountingStatement, ReconciliationGroup } from "../../types/reconciliation";
import { AccountingStatementsCard } from "./accountingStatementsTable/AccountingStatementsCard";
import { TitlesTableCard } from "./statementTitlesTable/TitlesTableCard";
import { StatementTitlesTableProvider } from "../../context/StatementTitlesTableContext";
import StatementTitlesTable from "./statementTitlesTable/StatementTitlesTable";
import { Card } from "antd";
import DownloadStatementTitlesButton from "./statementTitlesTable/DownloadStatementTitlesButton";

type SelectedEntity = {
  type: "ReconciliationGroup",
  entity: ReconciliationGroup,
} | {
  type: "AccountingStatement",
  entity: AccountingStatement,
} | undefined;


export const AccountingStatementTabContent = ({ viewType = "brokers" }: {
  viewType?: "brokers" | "statementTitles"
}) => {
  const [selectedEntity, setSelectedEntity] = useState<SelectedEntity>(undefined);
  const [previousEntity, setPreviousEntity] = useState<SelectedEntity>(undefined);

  return (
    <>
      {viewType === "brokers" && (
        <>
          {selectedEntity === undefined && (
            <ReconciliationGroupTableCard
              onTableRowSelect={(row) => {
                setSelectedEntity({ type: "ReconciliationGroup", entity: row });
                setPreviousEntity(undefined);
              }} />
          )}
          {selectedEntity?.type === "ReconciliationGroup" && (
            <AccountingStatementsCard
              navigationCardProps={(showsReconciliation) => ({
                previousSteps: [selectedEntity?.entity.broker_name],
                currentStep: showsReconciliation ? "Riconciliazione" : "Estratti conto",
                onPreviousStep: () => {
                  setSelectedEntity(undefined);
                  setPreviousEntity(undefined);
                }
              })}
              relatedReconciliationGroup={selectedEntity.entity}
              onTableRowSelect={(row) => {
                setPreviousEntity(selectedEntity);
                setSelectedEntity({ type: "AccountingStatement", entity: row });
              }}
            />
          )}
          {selectedEntity?.type === "AccountingStatement" && (<>
            <TitlesTableCard
              navigationCardProps={{
                previousSteps: [previousEntity?.type === "ReconciliationGroup" ? previousEntity?.entity.broker_name : "", "Estratti conto"],
                currentStep: selectedEntity.entity.document_name,
                onPreviousStep: () => {
                  setPreviousEntity(selectedEntity);
                  setSelectedEntity(previousEntity);
                }
              }}
              relatedAccountingStatement={selectedEntity.entity}
            />
          </>)}
        </>
      )}
      {viewType === "statementTitles" && (
        <StatementTitlesTableProvider>
          <Card title={"Lista titoli EC"} extra={<DownloadStatementTitlesButton />}>
            <StatementTitlesTable
              showConfirmedTitlesColumn={true}
            />
          </Card>
        </StatementTitlesTableProvider>
      )}
    </>
  );
};